import {useEffect} from "react";
import {useSignal} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";

import { WEBBACK_V2_API, GROUPED_BY } from "@constants";
import {commonFiltersValue, groupedBy, isLoadingCommonFilters, isSystemBusy} from "@signals";
import { elementsInLoading, catalogueAnalyzerTabSelected } from "../../@signals";


export default function useCatalogueAnalyzerGroupedVsSiteSearch() {
	const isLoading = useSignal(false)
	const data = useSignal([])
	const retailersList = useSignal([])
	const heatColorRanges = useSignal({})

	useEffect(() => {
		if (isLoadingCommonFilters.value) {
			isLoading.value = true
			data.value = []
			postSubmit(`${WEBBACK_V2_API}/catalogue/grouped-vs-site`, { 
				...commonFiltersValue.value, groupedBy: catalogueAnalyzerTabSelected.value
			}).then(res => {
				data.value = res.data
				retailersList.value = res.retailers
			}).catch(() => {
				isSystemBusy.value = true
				isLoadingCommonFilters.value = false
			}).finally(() => isLoading.value = false)
		}
	}, [isLoadingCommonFilters.value]);

	useEffect(() => {
		if (isLoading.value)
			elementsInLoading.value = [...elementsInLoading.value, 'priceNumProductsChart']
		else{
			elementsInLoading.value = elementsInLoading.value.filter(item => item !== 'priceNumProductsChart')
		}
	}, [isLoading.value])


	return {
		isLoading: isLoading.value,
		data: data.value,
		retailersList: retailersList.value,
		title: 'Top 20 Share of Products Per ' + (catalogueAnalyzerTabSelected.value === GROUPED_BY.BRAND ? 'Brands' : 'Category')
	}
}